import React from "react";
import {useLocation} from "react-router-dom";

interface NotFoundProps {
    className?: string;
}

// Shown for any address that isn't a page. The way home is the "home" button
// Block puts where the back button usually sits.
export function NotFound({className}: NotFoundProps) {
    const {pathname} = useLocation();
    return (
        <div className={className} id="notfound">
            <hr/>
            <p>
                There's nothing at <span className="nf-path">{pathname}</span>. It may have moved, or the link might have a typo.
            </p>
        </div>
    );
}
